export const reportError = (error: Error) => {
  // TODO: report errors to NewRelic, Sentry, etc.
  // eslint-disable-next-line no-console
  console.error(error);
};
